<app-loading [loading]="syncing()" width="24px" height="24px" align="start"></app-loading>
@if (!syncing() && syncedAnomalyDate()?.isFallback) {
  <app-status-tag color="info" label="ANOMALY_MAP_DATE_FALLBACK"></app-status-tag>
}
@if (!syncing() && syncedAnomalyDate()?.noImageryAvailable) {
  <app-status-tag color="danger" label="ANOMALY_MAP_NO_IMAGERY"></app-status-tag>
}
@if (!syncing() && syncedAnomalyDate()?.invalidDate) {
  <app-status-tag color="danger" label="ANOMALY_MAP_INVALID_DATE"></app-status-tag>
}
@if (!syncing() && syncedAnomalyDate()?.loadFailed) {
  <app-status-tag color="danger" label="ANOMALY_MAP_LOAD_FAILED"></app-status-tag>
}
